import type {
  AvatarContent,
  RedoAvatarSize,
} from "@redotech/arbiter/avatar/redo-avatar";
import { RedoAvatar } from "@redotech/arbiter/avatar/redo-avatar";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { memo } from "react";

function teamAvatarContent(
  name: string,
  logoUrl: string | undefined,
): AvatarContent {
  if (logoUrl) {
    return {
      type: "image",
      imageUrl: logoUrl,
      altText: name,
      backup: { type: "text", text: name },
    };
  }
  return { type: "text", text: name };
}

export const TeamAvatarLabel = memo(function TeamAvatarLabel({
  name,
  logoUrl,
  subtitle,
  size = "sm",
  to,
}: {
  name: string;
  logoUrl?: string;
  subtitle?: string;
  size?: RedoAvatarSize;
  to?: string;
}) {
  const identity = (
    <>
      <Flex aria-hidden as="span" gap="none" shrink={0}>
        <RedoAvatar content={teamAvatarContent(name, logoUrl)} size={size} />
      </Flex>
      <Flex dir="column" gap="none" minW="none">
        <Text
          fontSize="sm"
          fontWeight="medium"
          hoverTextColor={to ? "brand-primary" : undefined}
          textColor="primary"
        >
          {name}
        </Text>
        {subtitle && (
          <Text fontSize="xs" textColor="secondary">
            {subtitle}
          </Text>
        )}
      </Flex>
    </>
  );

  if (to) {
    return (
      <Flex
        align="center"
        as="a"
        gap="sm"
        grow={1}
        linkProps={{ to }}
        minW="none"
        textDecoration="none"
      >
        {identity}
      </Flex>
    );
  }

  return (
    <Flex align="center" gap="sm" grow={1} minW="none">
      {identity}
    </Flex>
  );
});
